export const title = ({ marginBottom = '56px', theme: { colors } }) => ({
    color: colors.text,
    marginBottom,
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '1.29',
    letterSpacing: '0.3px',
});
